import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface PanelSectionLinkProps {
    to: string;
    label: string;
}

export default function PanelSectionLink({ to, label }: PanelSectionLinkProps) {
    return (
        <Button
            component={RouterLink}
            to={to}
            size="small"
            sx={{
                alignSelf: "flex-start",
                textTransform: "none",
                fontWeight: 800,
                borderRadius: 999,
                px: 1.5,
            }}
        >
            {label}
        </Button>
    );
}
